import { Typography } from "@mui/material";
import FlexBox from "../../layouts/Flexbox";

function LabelWithIcon({
  label,
  icon,
  labelProps,
  endIcon,
  showIcon = true,
  onClick,
  clickableLabel,
  gap = 0.5,
}: any) {
  const renderIconWithLabel = () => {
    if (icon && endIcon)
      return (
        <FlexBox alignItems="center" gap={gap}>
          {icon}
          <Typography variant="standard" {...labelProps}>
            {label}
          </Typography>
          {endIcon}
        </FlexBox>
      );
    if (endIcon)
      return (
        <FlexBox alignItems="center" gap={gap}>
          <Typography variant="standard" {...labelProps}>
            {label}
          </Typography>
          {showIcon && endIcon}
        </FlexBox>
      );

    if (icon)
      return (
        <FlexBox alignItems="center" gap={gap}>
          {showIcon && icon}
          <Typography variant="body-ibmPlexMono" {...labelProps}>
            {label}
          </Typography>
        </FlexBox>
      );
  };

  const renderText = () => (
    <Typography
      onClick={() => clickableLabel && onClick()}
      {...labelProps}
      sx={{
        display: "flex",
        alignItems: "center",
        alignContent: "center",
        cursor: clickableLabel && "pointer",
      }}
    >
      {renderIconWithLabel()}
    </Typography>
  );

  return renderText();
}

export { LabelWithIcon };
